import React, { useState } from "react";
import { EyeIcon } from "@heroicons/react/solid";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import useGet from "../../hooks/read/useGet";
import toast from "react-hot-toast";
import Pagination from "../../components/pagination";
import PrimaryLoader from "../../components/common/PrimaryLoader";
import RoundedContainer from "../../components/containers/RoundedContainer";
import SearchBar from "../../components/inputs/SearchBar";
import { Button } from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";

const WebCheckIns = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling animation
    });
  };

  const initialEmployeeState = {
    page_number: searchParams.get("page_number") || 0,
    limit: searchParams.get("limit") || 10,
    search_query: searchParams.get("search_query") || "",
  };

  const {
    list: employeeList,
    paramsObject,
    setGetListParams,
  } = useGet({
    url: "employeelist",
    initialData: initialEmployeeState,
    onSuccess: () => {
      scrollToTop();
      // toast.success('Employees Fetched Successfully')
    },
    onError: () => {
      toast.error(
        "There Was An Error While Fetching The Data Please Try Again Later"
      );
    },
  });

  const handlePageClick = (val) => {
    let data = {
      ...paramsObject,
      page_number: val.selected,
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  const handleSearch = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let data = {
      ...paramsObject,
      [name]: value,
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  return (
    <section className="py-10">
      <RoundedContainer className="flex items-center justify-between mx-4">
        <div className=" w-[400px]">
          <SearchBar
            value={paramsObject.search_query}
            onChange={handleSearch}
          />
        </div>
      </RoundedContainer>
      {employeeList.isLoading ? (
        <div className=" flex items-center justify-center mt-10">
          {" "}
          <PrimaryLoader />
        </div>
      ) : (
        <>
          {employeeList?.data?.data?.length <= 0 ? (
            <div className="text-center">
              <p className=" text-gray-700 text-3xl">No Users To Show</p>
            </div>
          ) : (
            <RoundedContainer className="mx-4">
              <div className="max-w-full overflow-x-auto">
                <Table className="table-auto w-full">
                  <TableHead>
                    <TableHeaderCell className="w-[10%] text-center">
                      Sr.No
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[40%]">
                      Name
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[35%]">
                      Email
                    </TableHeaderCell>
                    {/* <TableHeaderCell className="w-[20%]">
                      User Type
                    </TableHeaderCell> */}
                    <TableHeaderCell className="w-[15%] text-center">
                      Web Check-ins
                    </TableHeaderCell>
                  </TableHead>
                  <TableBody>
                    {employeeList?.data?.data?.map((data, index) => {
                      const {
                        employee_name,
                        email,
                        company_employee_id,
                        type_of_employee,
                      } = data;
                      return (
                        <TableRow key={index}>
                          <TableCell className="text-center text-dark font-medium text-sm">
                            {paramsObject.page_number * paramsObject.limit + index + 1}
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm">
                            {employee_name}
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm">
                            {email}
                          </TableCell>
                          {/* <TableCell className="text-center text-dark font-medium text-sm capitalize">
                            {type_of_employee}
                          </TableCell> */}
                          <TableCell className="text-center">
                            <Link
                              to={`/web-check-ins/${company_employee_id}?name=${employee_name}`}
                              className="inline-flex items-center justify-center"
                            >
                              <Button
                                size="sm"
                                variant="default"
                                className="flex items-center space-x-1"
                              >
                                <EyeIcon className="w-4 h-4" />
                                <span>View</span>
                              </Button>
                            </Link>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            </RoundedContainer>
          )}
          {employeeList.data?.total_count > paramsObject.limit && (
            <RoundedContainer className="mx-4 mt-4">
              <Pagination
                currentPage={+paramsObject.page_number}
                lengthofItems={employeeList.data?.total_count}
                limit={+paramsObject.limit}
                onPageChange={handlePageClick}
              />
            </RoundedContainer>
          )}
        </>
      )}
    </section>
  );
};

export default WebCheckIns;
